import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

const getInitialCustomerReferMessageHtml = (
  toActorName: string | undefined,
  fromActorName: string | undefined,
  opportunityTitle: string | undefined,
  handlersName: string | undefined,
) =>
  renderToStaticMarkup(
    <div>
      <p>Hei,</p>
      <p>
        <br />
      </p>
      <p>{`Vi har henvist henvendelsen din "${opportunityTitle}" videre til ${toActorName}`}.</p>
      <p>
        <br />
      </p>
      <p>Med vennlig hilsen</p>
      <b>{handlersName}</b>
      <p>{fromActorName}</p>
    </div>,
  );

export default getInitialCustomerReferMessageHtml;
